'use client'

import { cn } from '@/lib/utils'
import { Plus } from 'lucide-react'
import Link from 'next/link'
import React from 'react'
import { TrashBin2Broken } from 'solar-icons'

import { VoidOrder } from '@/components/molecules'
import { Badge, Button, PriceBadge } from '@/components/ui'
import { DeleteCartButton } from './delete-cart-button'

interface OrderCardProps extends React.ComponentPropsWithoutRef<'div'> {
  order: any
}

export const OrderCard = ({ order }: OrderCardProps) => {
  const { cart, invoice_number, final_payble_amount, final_payable_amount } =
    order || {}

  const { reference, currency } = cart || {}

  const id = cart?.id ?? order?.id ?? ''
  const updated = cart?.updated_at ?? order?.updated_at ?? ''
  const status = cart?.status_payment ?? order?.status_payment ?? ''
  const count = order?.cart_items_count ?? order?.order_items?.length ?? ''

  return (
    <div className="flex w-full flex-col gap-2 rounded-lg border border-gray-100 bg-white py-2 pl-4 pr-4 shadow-card focus-within:bg-gray-50 hover:bg-gray-50 md:gap-0 lg:flex-row lg:items-center lg:justify-between">
      <Link
        href={!cart ? `/orders/${order?.id}` : '#'}
        className="flex w-full flex-col"
      >
        <div className="flex items-center gap-2">
          <h2 className="font-medium">
            #{id ?? invoice_number} {reference}
          </h2>
          <Badge
            size="md"
            variant={
              status === 'completed'
                ? 'green'
                : status === 'paid'
                  ? 'green'
                  : 'outline'
            }
            className="capitalize"
          >
            {status}
          </Badge>
        </div>
        <div className="flex flex-wrap items-center gap-2 text-sm text-gray-700">
          <span className="text-sm font-medium">{updated}</span>
        </div>
      </Link>

      <div className="flex flex-col gap-4 md:flex-row md:justify-between md:gap-10 lg:items-center lg:justify-start lg:gap-5">
        <div className="flex gap-5">
          <div className="flex items-center gap-2 text-sm font-semibold">
            <Badge size="md" variant="outline">
              {count}
            </Badge>
            <span>Products</span>
          </div>

          <PriceBadge
            price={final_payble_amount ?? final_payable_amount}
            className={cn('justify-end text-gray-950')}
            badge={{
              variant: 'default',
              size: 'md',
              children: currency,
              className: 'px-2 w-auto',
            }}
          />
        </div>

        <div className="flex items-center gap-2">
          {!cart && <VoidOrder orderId={id} />}

          {cart && (
            <React.Fragment>
              <Link href={`/sale?cartId=${id}`}>
                <Button variant="outline" className="shadow-card">
                  Restore
                  <Plus className="size-5" strokeWidth={1.5} />
                </Button>
              </Link>

              <DeleteCartButton cartId={id} />
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  )
}
